// extracted by mini-css-extract-plugin
export default {"label":"checkbox_label__UmB+m","input":"checkbox_input__6wOvU","checkmark":"checkbox_checkmark__yFB64"};